import { Navigate } from 'react-router-dom'
import { getDefaultDashboardRoute } from '@/lib/utils/get-default-dashboard-route'

/**
 * Component that redirects to the default dashboard route (reporting).
 */
export function DashboardRedirect() {
  const defaultRoute = getDefaultDashboardRoute(true)
  return <Navigate to={defaultRoute} replace />
}
